<template>
    <div class="g11c-faq">
        <details
            v-for="(item, index) in items"
            :key="`faq-${index}`"
            class="g11c-faq__item"
            :open="index === 0"
            @toggle="onToggle($event, index, item)"
        >
            <summary class="g11c-faq__trigger">
                <span class="g11c-faq__q">{{ item.q }}</span>
                <lucide-icon name="ChevronDown" :size="20" class="g11c-faq__chevron" aria-hidden="true" />
            </summary>
            <div class="g11c-faq__panel">
                <p class="g11c-faq__answer">{{ item.a }}</p>
            </div>
        </details>
    </div>
</template>

<script>
import LucideIcon from '@/components/welcome/landing/LucideIcon.vue';

export default {
    name: 'CurriculumFaqAccordion',
    components: { LucideIcon },
    props: {
        items: { type: Array, required: true },
    },
    methods: {
        onToggle(event, index, item) {
            if (event.target.open) {
                this.$emit('open', { index, question: item.q });
            }
        },
    },
};
</script>
